import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addressFormate'
})
export class AddressFormatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    console.log('Pipe Value : ', value, args);
    if(value){
      var val = value.toString().split(',');
      return val[0];
    }
    return null;
  }
}
